/* Add all URL paths and parameter names here */

const login = {
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot_password',
  CHECK_EMAIL: 'check_email',
  RESET_PASSWORD: 'reset_password/:token',
  CLAIM_ACCOUNT: 'claim_account/:token',
  REGISTRATION: 'registration',
  VERIFICATION: 'verification',
  PASSWORD: 'password',
  TOO_MANY_ATTEMPTS: 'too_many_attempts',
} as const;

const dashboard = {
  ACCOUNT: 'account',
  AGREEMENTS: 'agreements',
  AGREEMENT: 'agreement/:agreementId',
  BILLING: 'billing',
  DASHBOARD: 'dashboard',
  HARDWARE_INFO: 'hardware_information',
  OVERVIEW: 'overview',
  SYSTEM: 'system',
  VPP_DETAILS: 'vpp_details',
  VPP: 'vpp',
  VPP_FAQS: 'vpp_faqs',
  VPP_FAQ: 'vpp_faqs/:faqId',
} as const;

const support = {
  ACCOUNT_SUPPORT: 'account_support',
  BILL_PAYMENTS: 'bill_payments',
  PAYMENT_CALCULATIONS: 'payment_calculations',
  REAMORTIZATION: 'reamortization',
  SUPPORT: 'support',
  SYSTEM_PERFORMANCE: 'system_performance',
  SYSTEM_CHANGES: 'system_changes',
  VIDEO_RESOURCES: 'video_resources',
  AGREEMENT_TRANSFER: 'agreement_transfer',
  AGREEMENT_TRANSFER_STATUS: 'agreement_transfer_status',
  FAQ_QUESTION: 'faqs/:faqId',
} as const;

const admin = {
  ADMIN: 'admin',
  ADMINS: 'admins',
  USERS: 'users',
  USER: 'users/:userId',
  AGREEMENT: 'agreements/:agreementId',
  AGREEMENT_HOMEOWNER_CONTRACT_ID: 'contract/:homeownerContractId',
  AGREEMENT_WORKFLOW_ID: 'workflow/:workflowId',
  STATISTICS: 'statistics',
  MANAGE_FAQS: 'manage_faqs',
  AUTH_COPY_ACK: 'auth_copy_ack',
  BACKFILL: 'backfill',
} as const;

/** Pages responsible for executing business logic before rerouting the user to a different page */
const relay = {
  MAGIC_LINK_AUTHORIZE: 'magic_link',
  MYEVERBRIGHT_QR_RELAY: 'download_qr',
  OAUTH2_AUTHORIZE: 'authorize_oauth2',
};

export const pages = {
  ...login,
  ...dashboard,
  ...admin,
  ...support,
  ...relay,
  TRANSFER_REQUEST: 'transfer-request',
  AUTHORIZE: 'authorize',
  CHAT: 'chat',
  ERROR: 'error',
  FORCE_LOGOUT: 'force_logout',
  STATUS: 'status',
} as const;

export type PageKey = keyof typeof pages;

export type Page = (typeof pages)[PageKey];

export default pages;
